import { useState } from "react";
import { KnowledgeSearchBar } from "@/components/psychologist/home/KnowledgeSearchBar";
import { KnowledgeArticleView } from "@/components/psychologist/home/KnowledgeArticleView";
import { getArticleById, useKnowledgeBase } from "@/hooks/useKnowledgeBase";

/** Solapa "Políticas": buscador de solo lectura de la base de conocimiento (sin el asistente conversacional). */
export function PoliciesTab() {
  const { categories, isLoading, error } = useKnowledgeBase();
  const [articleId, setArticleId] = useState<string | null>(null);
  const article = articleId ? getArticleById(categories, articleId) : undefined;

  if (isLoading) return <p className="text-sm text-gray-500">Cargando…</p>;
  if (error)
    return (
      <p className="text-sm text-red-600">No pudimos cargar las políticas.</p>
    );
  if (article)
    return (
      <KnowledgeArticleView
        article={article}
        onBack={() => setArticleId(null)}
      />
    );
  return (
    <div className="space-y-2 text-sm">
      <p className="text-gray-600">
        Buscá una política (tolerancia, cancelaciones, protocolo de urgencias…).
      </p>
      <KnowledgeSearchBar
        categories={categories}
        onSelectArticle={setArticleId}
      />
    </div>
  );
}
